<template>
  <div class="login-buttons">
    <router-link
      :to="mailLoginPath"
      class="button is-medium login-buttons__btn login-buttons__btn--mail"
    >
      Mail + kode
    </router-link>
    <GoogleLoginButton v-if="clerkEnabled" />
    <button
      v-else
      type="button"
      class="button is-medium login-buttons__btn login-buttons__btn--google"
      disabled
      title="Mangler VUE_APP_CLERK_PUBLISHABLE_KEY"
    >
      <Icon name="google" />
      Google
    </button>
  </div>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue'
import { clerkEnabled, authRoutes } from '@/auth/config'
import Icon from '@/components/Icon.vue'

const components = { Icon }
if (clerkEnabled) {
  components.GoogleLoginButton = defineAsyncComponent(() => import('@/components/GoogleLoginButton.vue'))
}

export default defineComponent({
  components,
  setup() {
    return {
      clerkEnabled,
      mailLoginPath: authRoutes.mailLogin
    }
  }
})
</script>
